export const BASE_URL = "https://app.f-engelservice.com:5000";
export const IMG_URL = "https://app.f-engelservice.com:5000/";

export const ADMIN_LOGIN_API = BASE_URL + "/admin_login";
export const ADMIN_LOGOUT_API = BASE_URL + "/LogOut";
export const CHANGE_PASSWORD_API = BASE_URL + "/ChangePassword";
export const DELETE_ACCOUNT_API = BASE_URL + "/Delete_Account";
export const ALLOWED_MODULES_API = BASE_URL + "/get_allowed_modules";

export const LIST_LANGUAGES_API = BASE_URL + "/get_language";
export const DASHBOARD_COUNT_API = BASE_URL + "/dashboard_count";

export const USER_LIST_API = BASE_URL + "/Get_User";
export const ADD_USER_API = BASE_URL + "/Add_User";
export const EDIT_USER_API = BASE_URL + "/Edit_User";
export const DELETE_USER_API = BASE_URL + "/delete_user";

export const SUB_ADMIN_LIST_API = BASE_URL + "/get_sub_admin";
export const ADD_SUB_ADMIN_API = BASE_URL + "/register_sub_admin";
export const EDIT_SUB_ADMIN_API = BASE_URL + "/edit_sub_admin";
export const LIST_MODULES_API = BASE_URL + "/list_modules";

export const ADD_CATEGORY_API = BASE_URL + "/Add_Category";
export const CATEGORY_LIST_API = BASE_URL + "/GetCategory";
export const EDIT_CATEGORY_API = BASE_URL + "/Edit_Category";
export const ADD_CATEGORY_CONTACT_API = BASE_URL + "/add_category_contact";
export const DELETE_CONTACT_API = BASE_URL + "/deleteContact";
export const BLOCK_CATEGORY_API = BASE_URL + "/blockCategory";

export const SUBCATEGORY_LIST_API = BASE_URL + "/GetsubCategory";
export const ADD_SUBCATEGORY_API = BASE_URL + "/Add_SubCategory";
export const UPDATE_SUBCATEGORY_API = BASE_URL + "/Edit_Subcategory";
export const DELETE_SUBCATEGORY_API = BASE_URL + "/delete_Subcategory";
export const LIST_SUBCATEGORY_API = BASE_URL + "/without_subcategory";

export const GET_ROLE_API = BASE_URL + "/with_get_role";
export const ADD_ROLE_API = BASE_URL + "/Add_role";
export const UPDATE_ROLE_API = BASE_URL + "/edit_role";
export const LIST_ROLE_API = BASE_URL + "/get_role";
export const DELETE_ROLE_API = BASE_URL + "/delete_role";

export const GET_QUIZ_API = BASE_URL + "/getQuiz";
export const ADD_QUIZ_API = BASE_URL + "/Add_Quiz";
export const DELETE_QUIZ_API = BASE_URL + "/delete_quiz";
export const UPDATE_QUIZ_API = BASE_URL + "/Edit_Quiz";

export const ADD_WEBLINK_API = BASE_URL + "/Add_Weblink";
export const GET_WEBLINK_API = BASE_URL + "/GetWeblink";
export const UPDATE_WEBLINK_API = BASE_URL + "/Edit_Weblink";
export const DELETE_WEBLINK_API = BASE_URL + "/delete_weblink";

export const GET_NEWS_API = BASE_URL + "/GetNews";
export const ADD_NEWS_API = BASE_URL + "/AddNews";
export const UPDATE_NEWS_API = BASE_URL + "/Edit_News";
export const DELETE_NEWS_API = BASE_URL + "/delete_news";

export const GET_LANGUAGE_API = BASE_URL + "/list_language";
export const ADD_LANGUAGE_API = BASE_URL + "/Add_language";
export const UPDATE_LANGUAGE_API = BASE_URL + "/edit_language";

export const GET_QUESTION_API = BASE_URL + "/getquiz_question";
export const ADD_QUESTION_API = BASE_URL + "/Add_Question";
export const UPDATE_QUESTION_API = BASE_URL + "/Edit_Quiz_Question";
export const DELETE_QUESTION_API = BASE_URL + "/delete_question";

export const GET_PRODUCT_LIST = BASE_URL + "/list_items";
export const ADD_PRODUCT_API = BASE_URL + "/add_item";
export const DELETE_PRODUCT_API = BASE_URL + "/delete_item";
export const DELETE_PRODUCT_IMAGE_API = BASE_URL + "/delete_item_image";
export const UPDATE_PRODUCT_API = BASE_URL + "/update_item";
export const GET_PRODUCT_DETAILS = BASE_URL + "/get_item_details";

export const GET_CAMPAIGN_LIST = BASE_URL + "/list_campaign";
export const ADD_CAMPAIGN_API = BASE_URL + "/create_campaign";
export const DELETE_CAMPAIGN_API = BASE_URL + "/delete_campaign";
export const GET_CAMPAIGN_DETAILS = BASE_URL + "/get_campaign_detail";
export const UPDATE_CAMPAIGN_DETAILS = BASE_URL + "/update_campaign";

export const LIST_OFFER_API = BASE_URL + "/get_offer";
export const ADD_OFFER_API = BASE_URL + "/add_offer";
export const UPDATE_OFFER_API = BASE_URL + "/edit_offer";
export const DELETE_OFFER_API = BASE_URL + "/delete_offer";
export const OFFER_USERLIST_API = BASE_URL + "/get_offers_detail";

export const LIST_SHOP_API = BASE_URL + "/get_shop_link";
export const ADD_SHOP_API = BASE_URL + "/add_shop_link";
export const UPDATE_SHOP_API = BASE_URL + "/edit_shop_link";
export const DELETE_SHOP_API = BASE_URL + "/delete_shop_link";

export const LIST_SOCIAL_LINK_API = BASE_URL + "/get_social_link";
export const ADD_SOCIAL_LINK_API = BASE_URL + "/add_social_link";
export const UPDATE_SOCIAL_LINK_API = BASE_URL + "/edit_social_link";
export const DELETE_SOCIAL_LINK_API = BASE_URL + "/delete_social_link";

export const LIST_INFORMATION_API = BASE_URL + "/get_information";
export const ADD_INFORMATION_API = BASE_URL + "/add_information";
export const UPDATE_INFORMATION_API = BASE_URL + "/edit_information";
export const DELETE_INFORMATION_API = BASE_URL + "/delete_information";
